<rap-add-edit-role-ui [editableRole]="editableRole$ | async" [permissions]="permissions$ | async"
  [errorMessage]="errorMessage$ | async" [title]="title" (createNewRoleEmitter)="createNewRole($event)"
  (updateRoleEmitter)="updateRole($event)"></rap-add-edit-role-ui>